export const CircleCheckGreen = (): JSX.Element => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    fill="none"
    viewBox="0 0 14 14"
  >
    <path
      stroke="#5AB365"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M4.3 7l1.8 1.8 3.6-3.6M13 7A6 6 0 111 7a6 6 0 0112 0z"
    />
  </svg>
);
